/**
 * announcement-bar.js — crossfade rotator for the announcement bar.
 * Only rotates when there's more than one slide and data-autoplay is set.
 * Pauses on hover/focus; respects prefers-reduced-motion.
 */
import { Component } from '@theme/component';

class AnnouncementBar extends Component {
  mounted() {
    const refSlides = this.refs.slide;
    this.slides = Array.isArray(refSlides) ? refSlides : refSlides ? [refSlides] : [];
    this.index = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
    this._show(this.index);

    this.speed = (parseFloat(this.dataset.speed) || 5) * 1000;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.dataset.autoplay === 'true' && this.slides.length > 1 && !reduce) {
      this._start();
      this.addEventListener('mouseenter', () => this._stop());
      this.addEventListener('mouseleave', () => this._start());
      this.addEventListener('focusin', () => this._stop());
      this.addEventListener('focusout', () => this._start());
    }
  }

  unmounted() {
    this._stop();
  }

  next() {
    if (this.slides.length < 2) return;
    this.index = (this.index + 1) % this.slides.length;
    this._show(this.index);
  }

  prev() {
    if (this.slides.length < 2) return;
    this.index = (this.index - 1 + this.slides.length) % this.slides.length;
    this._show(this.index);
  }

  _show(i) {
    this.slides.forEach((slide, n) => slide.classList.toggle('is-active', n === i));
  }

  _start() {
    if (this.timer || this.slides.length < 2) return;
    this.timer = setInterval(() => this.next(), this.speed);
  }

  _stop() {
    clearInterval(this.timer);
    this.timer = null;
  }
}

customElements.define('announcement-bar-component', AnnouncementBar);
